export default class ActionType{
    
    constructor(payload = null) {
        this.payload=payload;
    }
    
    /**@abstract */
    ejecutar(estado, nuevoEstado = null){}
}